<!-- 任务列表日志弹窗 -->
<template>
    <div class="popup" v-cloak v-show="viewFailedFilesShow">
        <div class="content" id="viewFailedFiles">
            <div class="title">
                {{$t('language.popup.failedFilesPopup.title',{num:unfinishData.length})}}
                <div class="icon white-close dialog-close" @click="closePage()"></div>
            </div>
            <div class="view-failed-files-body">
                <div class="view-failed-files-table">
                    <el-table ref="viewFailedFilesTable" :data="unfinishData" border stripe tooltip-effect="dark" height="560" @selection-change="selectRetryFiles" @header-dragend="onHeaderDragEnd" style="width: 100%">
                        <el-table-column type="selection" width="26" > </el-table-column>
                        <el-table-column prop="file" :label="$t('language.common.transferFiles')" min-width="215" resizable>
                            <template slot-scope="scope">
                                <div :class="matchfileType(scope.row)" class="file_size_25"></div>
                                <div class="table-cell" :title="getFileName(scope.row)">{{getFileName(scope.row)}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="source" :label="$t('language.common.sourceDir')" min-width="380" resizable>
                            <template slot-scope="scope">
                                <div class="table-cell" v-if="scope.row.fromItem.driveType!=='Shares'" :title="scope.row.fromItem.nodes|getCatalog|getCatalogTitle">{{scope.row.fromItem.nodes|getCatalog}}</div>
                                <div class="table-cell" v-else :title="scope.row.fromItem.nodes|getCatalogShare|getCatalogTitle">{{scope.row.fromItem.nodes|getCatalogShare}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="size" :label="$t('language.common.size')" min-width="90" resizable>
                            <template slot-scope="scope">
                                <div v-if="scope.row.filesize" class="table-cell">{{scope.row.filesize|formatLogByte}}</div>
                                <div v-else class="table-cell">{{scope.row.size|formatLogByte}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="reason" :label="$t('language.common.failureReason')" min-width="400" resizable>
                            <template slot-scope="scope">
                                <div class="table-cell" v-if="scope.row.cause" :title="scope.row.cause|getCauseReason">{{scope.row.cause|getCauseReason}}</div>
                                <div class="table-cell" v-else :title="scope.row.exception|getCauseReason">{{scope.row.exception|getCauseReason}}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 用于下载 -->
                    <el-table id="viewFailedFilesData" :data="stringifiedItems" height="0" style="width: 0">
                        <el-table-column label="file">
                            <template slot-scope="scope">
                                {{getFileName(scope.row)}}
                            </template>
                        </el-table-column>
                        <el-table-column label="source" min-width="400">
                            <template slot-scope="scope">
                                <div v-if="scope.row.fromItem.driveType!=='Shares'">{{scope.row.fromItem.nodes|getCatalog}}</div>
                                <div v-else>{{scope.row.fromItem.nodes|getCatalogShare}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="size" min-width="90">
                            <template slot-scope="scope">
                                <div v-if="scope.row.filesize" >{{scope.row.filesize|formatLogByte}}</div>
                                <div v-else>{{scope.row.size|formatLogByte}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="reason" min-width="420">
                            <template slot-scope="scope">
                                <div v-if="scope.row.cause">{{scope.row.cause|getCauseReason}}</div>
                                <div v-else>{{scope.row.exception|getCauseReason}}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="view-failed-files-btns">
                    <div class="view-failed-files-tip" @click="jumpToLimitations();">
                        <div @mouseout="tipShow = false" @mouseover="tipShow = true">
                            <div class="icon-util question-mark question-mark-position"> </div>
                            <!-- <div class="explanation" v-if="tipShow">
                                <font></font>
                            </div> -->
                        </div>
                        <div>
                            {{$t('language.popup.limits')}}
                        </div>
                    </div>
                    <div>
                        <button @click="exportExcel()" style="float: left;margin-right: 32px;" v-if="stringifiedItems.length>0">
                            {{$t('language.popup.failedFilesPopup.exportExcel')}}
                        </button>
                        <!-- <button @click="retry()">
                            <div class="icon-util retry retry-button-position"></div>
                            {{$t('language.common.retry')}}<span v-if="selectedArr.length>0">{{"("+selectedArr.length+")"}}</span>
                        </button> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
import htmlTableToExcel from 'html-table-to-excel'

export default {
    name: "viewFailedFiles",
    computed: {
        stringifiedItems() {
            let temp = this.unfinishData.map(item => {
                const stringifiedItem = {};
                for (const [key, value] of Object.entries(item)) {
                    if(typeof value === 'object' && value !== null) {
                        //对象不处理
                        stringifiedItem[key] = value;
                    }else {
                        stringifiedItem[key] = value.toString();
                    }
                }
                return stringifiedItem;
            });
            return temp;
        },
    },
    data: function () {
        return {
            viewFailedFilesShow: false,
            loading: false,
            items: {},
            unfinishData: [],
            selectedArr: [],
            transferType: "",
            tipShow: false,
            retryAllData: [],
            taskName: "",
        }
    },
    watch: {
        unfinishData: {
            handler(newValue,oldVal) {
                this.initDate(newValue);
            },
        }
    },
    methods: {
        //监听列宽不得低于文本宽度
        onHeaderDragEnd(newWidth, oldWidth, column, event) {
            // 假设你的列是基于element-ui的el-table-column
            const minWidth = this.calculateWidth(column.label,16,"Arial")+30;
            if (newWidth < minWidth) {
                // 如果拖动后的宽度低于最小宽度，重置为最小宽度
                column.width = minWidth;
            }
        },
        //判断文本宽度
        calculateWidth(str, fontSize, fontFamily) {
            var canvas = document.createElement("canvas");
            var context = canvas.getContext("2d");
            context.font = "bold " + fontSize + "px " + fontFamily;
            var width = context.measureText(str).width;
            return width;
        },
        jumpToLimitations() {
            let language = commonUtils.getLocaleToIndex(localStorage.getItem("locale"));
            let link;
            if(language!='en'&&language!='nl'){
                link='https://www.multcloud.com/'+language+'/help/limitations.html';
            }else{
                link='https://www.multcloud.com/help/limitations.html';
            }
            window.open(link, "_blank");
        },
        initDate(detail) {
            console.log(detail)
            //默认全选
            this.$refs.viewFailedFilesTable.toggleAllSelection();
        },
        getFileName(item) {
            if(item.filename) {
                return item.filename;
            }else if(item.fileName) {
                return item.fileName;
            }else if(item.name) {
                return item.name;
            }else {
                return "";
            }
        },
        closePage() {
            this.loading = false;
            this.unfinishData = [];
            this.viewFailedFilesShow = false;
        },
        selectRetryFiles(val) {
            this.selectedArr = val;
        },
        matchfileType(item) {
            return "file_icon_"+commonUtils.matchfileTypes(this.getFileName(item));
        },
        //重试
        retry() {
            let that = this;
            let user = commonUtils.getUser();
            let remove;
            //流量不足弹窗提醒
            let usedTraffic = user.usedBytes;
            //  if(user.vip&&user.payLevel>1){
            //      usedTraffic = user.payUsedTraffic;
            //     }
            if (user.totalBytes != -1 && usedTraffic >= user.totalBytes) {
                this.$parent.$refs.upgradeDialog.upgradeShow = true;
                this.$parent.$refs.upgradeDialog.reset();
                this.$parent.$refs.upgradeDialog.trafficShow = true;
                return false;
            }
            let options;
            let retryData;
            that.$store.state.cancelAllFlag = false;
            let retryAllData = Object.assign([], this.selectedArr);//获取重试任务总长度
            let snapData= Object.assign([], this.$store.state.retryItems);//获取临时任务待处理列表任务总长度
            let uploadArr=Object.assign([], this.$store.state.uploadArr);//获取此时上传任务总长度
            if (retryAllData.length) {
                let allLength=snapData.length+uploadArr.length+retryAllData.length;//将所有要运行的临时任务求和
                if(allLength>200){//超过两百给出提示，并且只添加前200个任务
                    this.$toast({
                        text: this.$t('language.cloudExploer.simultaneous'),
                        type: 'fail',
                        idValue: "allBox"
                    });
                   
                      let index = allLength - 200;
                      retryAllData.splice(retryAllData.length - index,retryAllData.length + 1);
                      if(!retryAllData.length){
                          return;
                      }
                }
                this.retryAllData = retryAllData;
                this.selectedArr = [];
                    
                //多个任务集合
                let allItemsArr = [];
                for (let i = 0; i <= retryAllData.length - 1; i++) {
                    //获取当前文件任务id，并组装
                    let taskIndex = allItemsArr.findIndex(item => item.taskId == retryAllData[i].taskId);
                    if(taskIndex > -1) {

                    }else {
                        let len = allItemsArr.push({
                            taskId: retryAllData[i].taskId,
                            fromItemArr: [],
                            toItem: this.packageFromToItem(retryAllData[i].toItem)
                        });
                        
                        taskIndex = len - 1;

                        //如果源文件是文件夹重传的文件直接到目录
                        if(retryAllData[i].fromItem&&retryAllData[i].fromItem.isDir){
                            allItemsArr[taskIndex].toItem.fileId = retryAllData[i].desid;
                            allItemsArr[taskIndex].toItem.filename = retryAllData[i].desname;
                            allItemsArr[taskIndex].toItem.nodes.unshift({
                                fileId:allItemsArr[taskIndex].toItem.fileId,
                                filename:allItemsArr[taskIndex].toItem.filename
                            });
                        }
                    }

                    retryAllData[i].retryed = true;
                    //对重传数据的nodes格式进行封装为需要的格式
                    $.each(retryAllData[i].fromItem.nodes, function (index, item) {
                        if (item.fileName) {
                            item.filename = item.fileName;
                        }
                        delete item.cloudType;
                        delete item.tokenId;
                        delete item.fileName;
                    });
                    $.each(retryAllData[i].toItem.nodes, function (index, item2) {
                        if (item2.fileName) {
                            item2.filename = item2.fileName;
                        }
                        delete item2.cloudType;
                        delete item2.tokenId;
                        delete item2.fileName;
                    });

                    let fromItem = this.packageFromToItem(retryAllData[i].fromItem);
                    if(fromItem.driveType=='Shares'){
                        fromItem.way="share";
                    }
                    let filesize = retryAllData[i].filesize;
                    fromItem.filesize = filesize;
                    if (fromItem.nodes[0].fileId != retryAllData[i].fileid) {
                        let nodeItem = {
                            fileId: retryAllData[i].fileid,
                            filename: retryAllData[i].filename
                        }
                        let nodesOld = fromItem.nodes;
                        let nodesNew = [];
                        nodesNew.push(nodeItem);
                        $.each(nodesOld, function (index, nodeOld) {
                            nodesNew.push(nodeOld);
                        });
                        delete fromItem.nodes;
                        fromItem.nodes = nodesNew;
                        fromItem.fileId = fromItem.nodes[0].fileId;
                        fromItem.filename = fromItem.nodes[0].filename;
                        fromItem.isDir = false;
                    }
                    allItemsArr[taskIndex].fromItemArr.push(fromItem);
                    if (retryAllData[i].options) {
                        options = retryAllData[i].options;
                        options.isChar = 1;
                    } else {
                        options = {
                            isChar: 1
                        }
                    }
                    if(options.isRemove==1){
                        remove=true;
                    }
                }

                commonUtils.judgeNewDataFlag(that);
                //显示临时任务列表弹窗
                that.$store.state.snapTaskShow = true;

                allItemsArr.forEach(data => {
                    commonUtils.packageDetailData(data.fromItemArr,[data.toItem],remove);//把数据放在临时任务待执行弹窗       
                    data.addData = new taskTransferUtils.addTaskData(user.id, 4, data.fromItemArr[0].filename, data.fromItemArr, [data.toItem], options, null);
                });
                console.log(allItemsArr)

                Promise.all(allItemsArr.map(data => that.Utils.doTasksRequest('add', data.addData))
                ).then((results) => {
                    let allTaskNum = 0;
                    for (let i = 0; i < results.length; i++) {
                        if (results[i].status == 200) {
                            allTaskNum += allItemsArr[i].fromItemArr.length;
                            commonUtils.packageHaveDataDetail(results[i].tasks);//把返回的taskId给待处理任务
                        }else if(results[i].status == 400&&results[i].reason=='permissionFail'){
                            commonUtils.removeDataDetail(allItemsArr[i].addData);
                            that.$toast({
                                text: that.$t('language.exception.notPermission'),
                                type: 'fail',
                                idValue: "rightBodyList",
                                duration:5000
                            });
                        } else {
                            commonUtils.removeDataDetail(allItemsArr[i].addData);
                            that.$toast({
                                text: that.$t('language.exception.'+results[i].reason),
                                type: 'fail',
                                idValue: "rightBodyList",
                                duration:5000
                            });
                        }
                    };

                    that.$toast({
                        text: that.$t('language.popup.failedFilesPopup.retrySucTip',{num:allTaskNum}),
                        type: 'note',
                        idValue: "rightBodyList",
                        duration:5000
                    });

                    that.$store.state.cancelAllFlag = true;//清空按钮置为显示
                    commonUtils.letFlagTrue(that);

                }), err => {
                    that.$store.state.cancelAllFlag = true;//清空按钮置为显示
                    commonUtils.letFlagTrue(that);
                };
                 
            } else {
                this.$toast({
                    text: this.$t('language.common.selectNull'),
                    type: 'fail',
                    idValue: "rightBodyList"
                });
            }
        },
        packageFromToItem(fromToItem) {
            let item;
            fromToItem.fileId = fromToItem.id;
            fromToItem.filename = fromToItem.name;
            delete fromToItem.id;
            delete fromToItem.name;
            fromToItem.pid = fromToItem.nodes[fromToItem.nodes.length - 1].fileId;
            if (fromToItem.isDir) {
                item = new taskTransferUtils.DirItem(fromToItem.driveType, fromToItem.driveId, fromToItem.pid, fromToItem.fileId, fromToItem.filename, fromToItem.isDir, fromToItem.nodes);
            } else {
                item = new taskTransferUtils.FileItem(fromToItem.driveType, fromToItem.driveId, fromToItem.pid, fromToItem.fileId, fromToItem.filename, fromToItem.isDir, fromToItem.filesize, fromToItem.nodes);
            }
            return item;
        },
        //导出Excel
        exportExcel() {
            htmlTableToExcel(document.getElementById("viewFailedFilesData"),'MultCloud '+this.taskName+' Failed Files List');
        }
    }
}
</script>

<style scoped>
#viewFailedFiles {
    width: 1200px;
    /*no*/
    height: 700px;
    /*no*/
}

.view-failed-files-body {
    padding: 20px;
    /*no*/
    height: calc(100% - 80px);
    /*no*/
    position: relative;
    display: flex;
    flex-direction: column;
}

.view-failed-files-table {
    height: 560px;
    /*no*/
    border: 1px solid #C1CBE3;
    /*no*/
}

.view-failed-files-table >>> .el-table__header .el-table__cell {
    height: 40px;
    /*no*/
    padding: 0;
    background: #F9FBFE;
    border: 0;
}

.view-failed-files-table >>> .el-table__header .el-table__cell .cell {
    font-size: 14px;
    /*no*/
    color: #000000;
}

.view-failed-files-table >>> .el-table .el-table__cell {
    border: 0;
}

.view-failed-files-table >>> .el-table .el-table__cell .cell {
    padding-left: 10px;
    /*no*/
}

.view-failed-files-table >>> .el-table__header .el-table__cell:nth-last-child(3):before, 
.view-failed-files-table >>> .el-table__header .el-table__cell:nth-last-child(2):before {
    content: "";
    border-left: 1px solid #D3DCF0;
    /*no*/
    height: 12px;
    /*no*/
    position: absolute;
    top: calc(50% - 6px);
    /*no*/
    left: 0;
}

.view-failed-files-table >>> .el-table tbody td .cell {
    height: 50px;
    /*no*/
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
    width: 100%;
}

.view-failed-files-table >>> .el-table tbody td .cell .table-cell {
    height: 50px;
    /*no*/
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 50px;
    width: 100%;
}

.view-failed-files-table >>> .el-table td.el-table__cell {
    height: 50px;
    /*no*/
    padding: 0;
}

.small-file {
    height: 20px;
    /*no*/
    width: 20px;
    /*no*/
    float: left;
    margin-right: 4px;
    /*no*/
}

.view-failed-files-btns {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-grow: 1;
}

.view-failed-files-tip {
    display: flex;
    align-items: center;
    font-size: 14px;
    /*no*/
    line-height: 20px;
    /*no*/
    cursor: pointer;
}

.view-failed-files-tip:hover {
    text-decoration-line: underline;
}

.view-failed-files-tip:hover .question-mark {
    width: 20px;
    /*no*/
    height: 20px;
    /*no*/
    background-position: -2399px -204px;
    /*no*/
    cursor: pointer;
}

.view-failed-files-btns button {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 128px;
    /*no*/
}

.view-failed-files-btns .icon-util{
    margin-right: 5px;
    /*no*/
}

.view-failed-files-table >>>.el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #DCDFE6;
}

.view-failed-files-table >>>.el-table__body-wrapper::-webkit-scrollbar {
    width: 8Px;
    /*no*/
    height: 8Px;
    /*no*/
    background-color: transparent;
}

.view-failed-files-table >>>.el-table__body-wrapper::-webkit-scrollbar-thumb {
    height: 1Px;
    /*no*/
    border-radius: 5Px;
    /*no*/
    background-color: #becae4;
}

.view-failed-files-table >>>.el-table__body-wrapper::-webkit-scrollbar-track {
    background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/task_list_popups/view_failed_files_popup.vue